import { useEffect, useMemo, useRef } from 'react';
import { smartlookIdentifyUser, smartlookResetIdentity } from 'utils/analytics/smartlook';

interface SmartlookUser {
  id?: number | string | null;
  firstName?: string | null;
  lastName?: string | null;
  cognitoUsername?: string | null;
  email?: string | null;
}

interface SmartlookIdentityProps {
  user?: SmartlookUser;
  tenant?: string;
  project?: string;
}

export function useSmartlookIdentity({ user, tenant, project }: SmartlookIdentityProps) {
  const isInitialized = useRef(false);

  const identityData = useMemo(() => {
    const name = user
      ? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() || user.cognitoUsername || undefined
      : undefined;
    return {
      name,
      email: user?.email,
      tenant,
      project,
    };
  }, [user, tenant, project]);

  useEffect(() => {
    if (!user?.id) return;

    if (!isInitialized.current) {
      smartlookIdentifyUser(user, { tenant, project });
      isInitialized.current = true;
    } else {
      smartlookResetIdentity(user, { tenant, project });
    }
  }, [tenant, project, user]);

  return identityData;
}
